import type { PendingReposicionPush, PendingReposicionRow } from './models/ReposicionCatalog.ts';
import type { SyncPushStoredMediaRef } from '@core/domain/sync/SyncPushResult.ts';

export type ReposicionSyncMediaIssue = {
  reposicionPublicId: string;
  message: string;
};

export function mediaIdsForStoredReposicionSync(
  pending: PendingReposicionRow[],
  acceptedPublicIds: readonly string[],
  storedMedia: readonly SyncPushStoredMediaRef[],
): string[] {
  const accepted = new Set(acceptedPublicIds);
  const storedById = new Map(storedMedia.map((row) => [row.publicId, row]));
  const mediaIds = new Set<string>();
  for (const row of pending) {
    if (!accepted.has(row.publicId)) continue;
    const stored = storedById.get(row.publicId);
    if (!stored) continue;
    if (row.firmaMediaId && stored.firmaRef) mediaIds.add(row.firmaMediaId);
    if (row.fotoMediaId && stored.fotoRef) mediaIds.add(row.fotoMediaId);
  }
  return [...mediaIds];
}

/** Accepted reposición rows with local media but no matching server refs — purge intentionally skipped. */
export function countReposicionMediaPurgeSkipped(
  pending: PendingReposicionRow[],
  acceptedPublicIds: readonly string[],
  storedMedia: readonly SyncPushStoredMediaRef[],
): number {
  const accepted = new Set(acceptedPublicIds);
  const storedById = new Map(storedMedia.map((row) => [row.publicId, row]));
  let skipped = 0;
  for (const row of pending) {
    if (!accepted.has(row.publicId)) continue;
    const stored = storedById.get(row.publicId);
    if (row.firmaMediaId && !stored?.firmaRef) skipped += 1;
    if (row.fotoMediaId && !stored?.fotoRef) skipped += 1;
  }
  return skipped;
}

/** Firma/foto base64 optional on push — never blocks sync. Usuario required. */
export function reposicionSyncPushPayloadIssues(
  _pending: PendingReposicionRow[],
  payload: PendingReposicionPush[],
): ReposicionSyncMediaIssue[] {
  const issues: ReposicionSyncMediaIssue[] = [];
  for (const row of payload) {
    if (!row.usuarioPublicId?.trim()) {
      issues.push({
        reposicionPublicId: row.publicId,
        message: 'Falta el id del usuario en la sesión. Cierre sesión e inicie de nuevo.',
      });
    }
  }
  return issues;
}

export function reposicionSyncMediaAckIssues(
  _pending: PendingReposicionRow[],
  _acceptedPublicIds: readonly string[],
  _storedMedia: readonly SyncPushStoredMediaRef[],
): ReposicionSyncMediaIssue[] {
  return [];
}
